import React from "react";
import TalentoCard from "./TalentoCard";
import { Col, Form } from "react-bootstrap";
import Navigation from "components/Navigation";
import WarningNotiifcation from 'components/WarningNotification';

const TalentoDetalle = ({ user }) => {
  return (
    <div>
      {user.persona &&
      user.persona.personaTalentos &&
      user.persona.personaTalentos.length > 0 &&
      user.persona.personaTalentos.filter((x) => x && x.estado == 1)
        .length > 0 ? (
        user.persona.personaTalentos
          .filter((x) => x && x.estado == 1)
          .map((talento) => {
            return (
              <TalentoCard
                key={talento.id}
                talento={talento}
              />
            );
          })
      ) : (
        <Form.Group as={Col} md="12">
          <WarningNotiifcation
            message="No ha agregado  "
            enphasis="Talentos"
          />
        </Form.Group>
      )}
      <Navigation beforeUrl="/language" continueUrl="/knowledgeAndSkillsModule" />
    </div>
  );
};

export default TalentoDetalle